import { render, staticRenderFns } from "./customerInformationAdd.vue?vue&type=template&id=5b704daa&scoped=true&"
import script from "./customerInformationAdd.vue?vue&type=script&lang=js&"
export * from "./customerInformationAdd.vue?vue&type=script&lang=js&"
import style0 from "./customerInformationAdd.vue?vue&type=style&index=0&id=5b704daa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b704daa",
  null
  
)

export default component.exports